// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-configuration {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  top: 1%;
  left: 2%;
  height: 40px;
  color: #fff;
  margin: 0px 10px;
  padding: 0px 10px;
}
.overlay-configuration span {
  margin-left: 20px;
  font-size: smaller;
}

.configuration-container {
  position: absolute;
  background: rgba(88, 88, 88, 0.8);
  border-radius: 10px;
  top: 80px !important;
  bottom: 25px !important;
  width: 185px;
  z-index: 1;
  padding: 7px 12px;
  margin-top: 30px;
  margin-left: 10px;
}

.constellation-select {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: nowrap;
}

.configuration-row {
  display: flex;
  flex-direction: row;
}
.configuration-row > div {
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./src/satmon/modules/configuration/configuration.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;AAAF;AAEE;EACE,iBAAA;EACA,kBAAA;AAAJ;;AAQA;EACE,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,YAAA;EAEA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;AANF;AAOE;EACE,iBAAA;AALJ","sourcesContent":[".overlay-configuration {\n  position: absolute;\n  // background: rgb(88, 88, 88, 0.8);\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  top: 1%;\n  left: 2%;\n  height: 40px;\n  color: #fff;\n  margin: 0px 10px;\n  padding: 0px 10px;\n\n  span {\n    margin-left: 20px;\n    font-size: smaller;\n\n  }\n\n  ;\n}\n\n\n.configuration-container {\n  position: absolute;\n  background: rgb(88, 88, 88, 0.8);\n  border-radius: 10px;\n  top: 80px !important;\n  bottom: 25px !important;\n  width: 185px;\n  // left: 10px !important;\n  z-index: 1;\n  padding: 7px 12px;\n  margin-top: 30px;\n  margin-left: 10px;\n}\n\n.constellation-select {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.configuration-row {\n  display: flex;\n  flex-direction: row;\n  >div{\n    margin-right: 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
